<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="addItemTypeModal" persistent max-width="530px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('customer.addItemTypeTitle') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeAddItemTypeModal(), $validator.reset()" class="close"
                  ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="checkAlert">
                {{ $t('customer.itemAddedSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      :label="$t('customer.itemType') + '*'"
                      v-model="addItemTypeData.type_name"
                      :error-messages="errors.collect('Item type')"
                      v-validate="'required'"
                      data-vv-name="Item type"
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      :label="$t('customer.shippingPrice') + '*'"
                      v-model="addItemTypeData.type_int_shipping_price"
                      :error-messages="errors.collect('Shipping price')"
                      v-validate="'required|decimal:2'"
                      data-vv-name="Shipping price"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddItemTypeModal(), $validator.reset()"
                outline
                color="normal"
                >{{ $t('common.cancel') }}</v-btn
              >
              <v-btn type="submit" style="height:auto" class="rtl-mr-4pct" outline color="primary"
                >{{ $t('common.add') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'addItemTypeModal',
    'closeAddItemTypeModal',
    'checkAlert',
    'addItemTypeData',
    'addItemType'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.addItemType()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addItemType.vue